<div class="default-dialog-wrapper mat-elevation-z10 dr-dialog">
  <div class="flex flex-row content pt-20 pr-24 pb-20 pl-24">
    <div class="flex flex-col w-100-percent">
      <div class="flex flex-row w-100-percent">
        <h1 class="flex flex-wrap basis-full mat-headline-5 mb-14 fw-700 mr-98">{{title}}</h1>
        <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" [matDialogClose]="false"></mat-icon>
      </div>

      <div class="mat-body-1 fw-400 tracking-normal mr-24 mb-12 mt--6">
        <span [innerHTML]="message"></span>
        <div class="mat-subtitle-2 fw-600 mb-6 mt-16">{{ 'DISASTER_RECOVERY.CHOOSE_DR_MODE' | transloco }}</div>
      </div>

      <div class="flex flex-col self-start mb-16" *ngIf="optionSelection?.length > 0">
        <div class="flex flex-row gap-4">
          <div *ngFor="let option of optionSelection" class="flex flex-row items-center cursor-pointer" (click)="selectOptions(option)">            
            <mat-icon [svgIcon]="option.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="icon-md mr-8"></mat-icon>
            <span class="mat-body-2">{{option.label}}</span>
          </div>
        </div>
      </div>

      <div class="dr-details-box mb-16">
        <div class="flex flex-row mb-12">
          <div class="detail-label">{{ 'DISASTER_RECOVERY.ENVIRONMENT' | transloco }}</div>
          <div class="detail-separator">:</div>
          <div class="detail-value">{{drDetails?.environment}}</div>
        </div>
        <div class="flex flex-row mb-12">
          <div class="detail-label">{{ 'DISASTER_RECOVERY.TYPE' | transloco }}</div>
          <div class="detail-separator">:</div>
          <div class="detail-value">{{(selectedOption?.value | titlecase) || drDetails?.type}}</div>
        </div>
        <div class="flex flex-row mb-12">
          <div class="detail-label">{{ 'DISASTER_RECOVERY.FROM' | transloco }}</div>
          <div class="detail-separator">:</div>
          <div class="detail-value">{{drDetails?.from}}</div>
        </div>
        <div class="flex flex-row">
          <div class="detail-label">{{ 'DISASTER_RECOVERY.TO' | transloco }}</div>
          <div class="detail-separator">:</div>
          <div class="detail-value">{{drDetails?.to}}</div>
        </div>
      </div>

      <div class="flex flex-row items-center mb-16 cursor-pointer" (click)="toggleDrAckCheckbox()">
        <mat-icon [svgIcon]="drAckCheckbox ? 'check_box' : 'check_box_outline_blank'" class="icon-md mr-8"></mat-icon>
        <span class="mat-body-2">{{drAckText}}</span>
      </div>

      <mat-divider class="neutral-blue-7 w-100-percent mt-4 mb-4"></mat-divider>

      <div class="flex flex-row justify-end w-100-percent mt-16">
        <button class="cancel-btn-dr mr-12" (click)="onCancel()">{{cancelButtonText}}</button>
        <button class="confirm-btn-dr" [disabled]="!selectedOption || !drAckCheckbox" (click)="onConfirm()">{{confirmButtonText}}</button>
      </div>
    </div>
  </div>
</div>
